import { FC } from 'react';
import { InputText } from '@lambdacurry/component-library';
import { InputGrid, InputGridProps } from '../InputGrid';

export interface NameInputGroupProps extends InputGridProps {
  name?: string;
}

export const NameInputGroup: FC<NameInputGroupProps> = ({ name, ...props }) => {
  const fieldPrefix = name ? `${name}.` : '';

  return (
    <InputGrid {...props}>
      <div className="md:col-span-6">
        <InputText name={`${fieldPrefix}first_name`} label="First Name" />
      </div>
      <div className="md:col-span-6">
        <InputText name={`${fieldPrefix}last_name`} label="Last Name" />
      </div>
    </InputGrid>
  );
};
